export default __webpack_public_path__ + "static/media/Saly-14.23824042.svg";